import * as React from 'react';
import { ComponentProps, FlexValidation, ValidationProps } from 'ui';
import styles from './flex-row-panel.scss';

export interface FlexRowPanelProps extends ComponentProps {
  children: any;
  validation?: ValidationProps;
}

export const FlexRowPanel: React.FC<FlexRowPanelProps> = (props: FlexRowPanelProps) => {

  const {
    componentId,
    children,
    validation
  } = props;

  const hasVisibleChildren = React.Children.toArray(children).length > 0;

  return hasVisibleChildren ? (
    <div id={componentId} className={`row flex-row-panel ${styles.panel}`}>
      <FlexValidation {...validation}/>
      {children}
    </div>
    ) : null;
};
